import { Box, Portal } from '@chakra-ui/react'
import { FocusLock } from '@chakra-ui/focus-lock'
import { useRef } from 'react'

import useScrollLock from 'lib/hooks/useScrollLock'

interface OverlayProps {
  show: boolean
}

const Overlay: React.FC<OverlayProps> = ({ show, children }) => {
  const focusTrapRef = useRef<HTMLDivElement | null>(null)

  useScrollLock(show)

  return show ? (
    <Portal>
      <FocusLock initialFocusRef={focusTrapRef}>
        <Background>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            w="100vw"
            h="100vh"
            ref={focusTrapRef}
            tabIndex={0}
          >
            <Box>{children}</Box>
          </Box>
        </Background>
      </FocusLock>
    </Portal>
  ) : null
}

const Background: React.FC = ({ children }) => (
  <Box
    h="100vh"
    w="100vw"
    left="0"
    top="0"
    zIndex="fullScreenOverlay"
    position="fixed"
    bgColor="authOverlay"
  >
    {children}
  </Box>
)

export default Overlay
